export const montarPayloadReativacaoUsuario = (oUsuario) => {
  const mQueueIds = (oUsuario.queues || []).map((oFila) => oFila.id).filter((nId) => nId != null)

  return {
    name: oUsuario.name,
    nomeAbreviacao: oUsuario.nomeAbreviacao,
    email: oUsuario.email,
    profile: oUsuario.profile,
    whatsappId: oUsuario.whatsappId ?? null,
    queueIds: mQueueIds,
    allTicket: oUsuario.allTicket,
    verMensagensMesmoPerfil: oUsuario.verMensagensMesmoPerfil,
    ativo: true,
  }
}
